{
  "vedleggliste_tittel": "Vedlegg",
  "clientOperation_GetRegisteroppforing_Warning_Title": "Visningen kan være ufullstendig",
  "clientOperation_GetRegisteroppforing_Warning_Body": "Noen systemer svarer for øyeblikket ikke. Prøv igjen senere.",
  "page_forskning_title": "Forskning og screening",
  "page_forskning_desc": "Her ser du hvilke screeningprogram du har fått tilbud om, og hvilke kliniske studier eller helseundersøkelser du deltar i.",
  "expandButtonCloseText": "Vis mindre",
  "expandButtonText": "Les mer",
  "generisk_response_error_title": "Det har skjedd en teknisk feil",
  "generisk_response_error_description": "Prøv igjen senere.",
  "generisk_table_caption": "Statuslogg",
  "kliniskeStudierLinkText": "Her kan du lese mer om",
  "kliniskeStudierLinkText2": "kliniske studier.",
  "emptyList": "Du er foreløpig ikke registrert som deltaker i noen screeningprogrammer eller forskningsprosjekter som vises i tjenesten.",
  "informasjonLenkePrefix": "Les mer om",
  "innsynsrettLenkePrefix": "Les mer om innsynsrett i",
  "databehandlingsansvarlig": "er dataansvarlig."
}
